import { put, takeLatest } from "redux-saga/effects";
import {
  requestmanageRoleList,
  requestCreateRole,
  requestupdateRole,
  requestDeleteRole,
  requestAddFeatureRole,
} from "services/manageRole";
import {
  fetchmanageRoleListRequest,
  fetchmanageRoleListSuccess,
  fetchmanageRoleListFaliure,
  createmanageRoleFaliure,
  createmanageRoleSuccess,
  createmanageRoleRequest,
  updatemanageRoleRequest,
  updatemanageRoleSuccess,
  updatemanageRoleFaliure,
  deletemanageRoleRequest,
  deletemanageRoleSuccess,
  deletemanageRoleFaliure,
  addFeatureRoleRequest,
  addFeatureRoleSuccess,
  addFeatureRoleFaliure,
} from "redux/reducers/manageRoles";

export function* watchmanageRoleSaga() {
  yield takeLatest(fetchmanageRoleListRequest, fetchRoles);
  yield takeLatest(createmanageRoleRequest, createRole);
  yield takeLatest(updatemanageRoleRequest, updateRole);
  yield takeLatest(deletemanageRoleRequest, deleteRole);
  yield takeLatest(addFeatureRoleRequest, addFeature);
}
function* fetchRoles({ payload }) {
  try {
    const response = yield requestmanageRoleList(payload);
    yield put(fetchmanageRoleListSuccess(response));
  } catch (error) {
    yield put(fetchmanageRoleListFaliure("failed to get list of roles"));
  }
}
function* createRole({ payload }) {
  try {
    const response = yield requestCreateRole(payload);
    yield put(createmanageRoleSuccess(response.data));
  } catch (error) {
    yield put(createmanageRoleFaliure(error));
  }
}
function* updateRole({ payload }) {
  try {
    const response = yield requestupdateRole(payload);
    yield put(updatemanageRoleSuccess(response.data));
  } catch (error) {
    yield put(updatemanageRoleFaliure("Failed to get update Role"));
  }
}
function* deleteRole({ payload }) {
  try {
    const response = yield requestDeleteRole(payload);
    yield put(deletemanageRoleSuccess(response));
  } catch (error) {
    yield put(deletemanageRoleFaliure("Failed to Delete update Role"));
  }
}
function* addFeature({ payload }) {
  try {
    const response = yield requestAddFeatureRole(payload);
    yield put(addFeatureRoleSuccess({ response, roleid: payload.id }));
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update role";
    yield put(addFeatureRoleFaliure(msg));
  }
}
